import React from 'react';
import '../styles.css';

const Sidebar = ({
  isSidebarVisible,
  currentUser,
  activeRole,
  error,
  handleSwitchRole,
  handleLogout,
  menuItems,
}) => {
  const isAdmin = currentUser?.role_name === 'admin';
  
  const defaultMenuItems = [
    { icon: '&#127968;', label: 'Dashboard', path: '/admin-manager-lead-dashboard', active: true },
    { icon: '&#128196;', label: 'AR Requests', path: '/all-requests', active: false },
    // { icon: '&#128197;', label: 'Calendar', path: '/calendar', active: false },
    { icon: '&#128178;', label: 'Payroll', path: 'https://hrms.teamhalt.com/', active: false },
  ];

  const adminItems = [
    { icon: '&#128101;', label: 'Employees', path: '/employees', active: false },
    { icon: '&#127970;', label: 'Roles & Office', path: '/roles-office', active: false },
    { icon: '&#128197;', label: 'Leaves Admin', path: '/leaves-admin', active: false },
    { icon: '&#128197;', label: 'Attendance Admin', path: '/attendance-admin', active: false },
  ];

  const employeeItems = [
    { icon: '&#127968;', label: 'Dashboard', path: '/user-dashboard', active: true },
    { icon: '&#128100;', label: 'My Profile', path: `/user-profile/${currentUser?.id}`, active: false },
    { icon: '&#128203;', label: 'Leave Management', path: `/leave-management/${currentUser?.id}`, active: false },
    // { icon: '&#128197;', label: 'Calendar', path: '/calendar', active: false },
    // Payroll removed from employee/user sidebar
  ];


  const items = menuItems || defaultMenuItems;

  return (
    <div className={`app-sidebar ${isSidebarVisible ? 'sidebar-visible' : 'sidebar-hidden'}`}>
      <div className="sidebar-header">
        <div className="sidebar-user-info">
          <div className="user-avatar">
            {currentUser?.first_name?.charAt(0) || 'U'}
          </div>
          <div className="user-details">
            <h3 className="user-name">
              {currentUser?.isAdmin ? 'Admin' : currentUser?.first_name || currentUser?.name}
            </h3>
            <span className="user-role">
              [{currentUser?.role_name || activeRole || 'Employee'}]
            </span>
          </div>
          {handleSwitchRole && (
            <button 
              className="role-toggle-btn"
              onClick={handleSwitchRole}
              title="Switch Role"
            >
              <span className="toggle-switch">
                <span className="toggle-knob"></span>
              </span>
            </button>
          )}
        </div>
        
        {error && <div className="sidebar-error">{error}</div>}
      </div>

      <nav className="sidebar-nav">
        <ul className="sidebar-menu">
          {items.map((item, index) => (
            <li key={index} className="sidebar-menu-item">
              {item.action ? (
                <button 
                  className="sidebar-menu-link sidebar-menu-btn"
                  onClick={item.action}
                >
                  <span className="menu-icon" dangerouslySetInnerHTML={{ __html: item.icon }}></span>
                  <span className="menu-label">{item.label}</span>
                </button>
              ) : (
                <a 
                  className="sidebar-menu-link"
                  href={item.path}
                  target={item.path.startsWith('http') ? '_blank' : undefined}
                  rel={item.path.startsWith('http') ? 'noopener noreferrer' : undefined}
                >
                  <span className="menu-icon" dangerouslySetInnerHTML={{ __html: item.icon }}></span>
                  <span className="menu-label">{item.label}</span>
                </a>
              )}
            </li>
          ))}

          {items === defaultMenuItems && (currentUser?.role_name === 'admin' || currentUser?.role_name === 'manager') && (
            <>
              <li className="sidebar-menu-divider">
                <span>Management</span>
              </li>
              {adminItems.map((item, index) => (
                <li key={index} className="sidebar-menu-item">
                  <a 
                    className="sidebar-menu-link"
                    href={item.path}
                    target={item.path.startsWith('http') ? '_blank' : undefined}
                    rel={item.path.startsWith('http') ? 'noopener noreferrer' : undefined}
                  >
                    <span className="menu-icon" dangerouslySetInnerHTML={{ __html: item.icon }}></span>
                    <span className="menu-label">{item.label}</span>
                  </a>
                </li>
              ))}
            </>
          )}
        </ul>
      </nav>

      <div className="sidebar-footer">
        <button 
          className="sidebar-logout-btn"
          onClick={() => handleLogout()}
        >
          <span className="logout-icon">&#128682;</span>
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
